import React from "react"

import { Typography, Divider, Grid } from "@material-ui/core"
import { makeStyles } from "@material-ui/core/styles"
import { FormattedMessage } from "react-intl"

const useStyle = makeStyles(theme => ({
  container: {
    width: "100%",
    margin: "auto",
    paddingTop: "50px",
    paddingBottom: "50px",
  },
  title: {
    fontSize: "28px",
    fontWeight: 600,
    paddingTop: "8px",
    color: "#333333",
    fontFamily: "ヒラギノ角ゴ ProN",
    lineHeight: "34px",
  },
  description: {
    fontSize: "16px",
    fontWeight: 300,
    color: "#333333",
    paddingTop: "29px",
    fontFamily: "ヒラギノ角ゴ ProN",
    lineHeight: "28px",
  },
}))

const AgreementCardTitle = ({ name }) => {
  const classes = useStyle()

  return (
    <>
      <Grid container className={classes.container}>
        <Grid item>
          <Typography className={classes.title} id="agreementCardTitle">
            <FormattedMessage id="AgreementCardTitle.Title" />
          </Typography>
          <Typography
            className={classes.description}
            id="agreementCardDescription"
          >
            <FormattedMessage
              id="AgreementCardTitle.Description"
              values={{
                name: name,
              }}
            />
          </Typography>
        </Grid>
      </Grid>
      <Divider />
    </>
  )
}

export default AgreementCardTitle
